import { ExportToExcel } from '@/services/excel/generator/excelGenerator';
import ExportExcel from '@/services/excel/generator/exportExcel';
import SheetExcel from '@/services/excel/generator/sheetExcel';
import ColumnExcel from '@/services/excel/generator/columnExcel';

export const columnsFacture = [
  new ColumnExcel('Type', 'type', true),
  new ColumnExcel('Code', 'code', true),
  new ColumnExcel('Date', 'dateDevisCommande', true),
  new ColumnExcel('Agence', 'agence', true),
  new ColumnExcel('Commercial(e)', 'commercial'),
  new ColumnExcel('Assistant(e)', 'assistant'),
  new ColumnExcel('Annonceur', 'annonceur', true),
  new ColumnExcel('Payeur', 'payeur', true),
  new ColumnExcel('Mandataire', 'mandataire'),
  new ColumnExcel('Donneur d\'ordre', 'donneurOrdre', true),
  new ColumnExcel('Etat', 'etat', true),
  new ColumnExcel('Code dossier', 'codeDossier'),
  new ColumnExcel('Thème de campagne', 'theme'),
  new ColumnExcel('Date de campagne', 'datePremierAffichage', true),
  new ColumnExcel('Mode de règlement', 'modeReglement', true),
  new ColumnExcel('Délai de règlement', 'delaiReglement', true),
  new ColumnExcel('Renouvelable', 'renouvelable'),
  new ColumnExcel('Reconductible tacitement', 'reconductible'),
  new ColumnExcel('Date de renouvellement', 'dateRenouvellement'),
  new ColumnExcel('Date de préavis', 'datePreavis'),
  new ColumnExcel('Montant HT', 'montantHt', true),
  new ColumnExcel('Commentaire Interne', 'commentaireInterne'),
  new ColumnExcel('Commentaire commande', 'commentaire'),
];

export const columnsLigneFacture = [
  new ColumnExcel('Code commande', 'codeCommande', true),
  new ColumnExcel('Code produit patrimonial', 'codeProduit'),
  new ColumnExcel('Libellé produit', 'libelleProduit'),
  new ColumnExcel('Code produit de vente', 'referenceProduit', true),
  new ColumnExcel('Libelle ligne de commande', 'libelle', true),
  new ColumnExcel('Date de début', 'dateDebut'),
  new ColumnExcel('Date de fin', 'dateFin'),
  new ColumnExcel('Pourcentage surface', 'quantiteDispo'),
  new ColumnExcel('Faces prévues', 'ligneReseau.qteFacesPrevues'),
  new ColumnExcel('Années Semaine', 'ligneReseau.AnneeSemaine'),
  new ColumnExcel('Quantité', 'quantite', true),
  new ColumnExcel('Prix unitaire', 'prixUnitaire', true),
  new ColumnExcel('Remise en pourcentage', 'remise'),
  new ColumnExcel('Taux TVA', 'tauxTVA', true),
];

export function templateConfig(data) {
  return new ExportExcel(
    'TemplateFacture.xlsx',
    [
      new SheetExcel(
        'Facture',
        columnsFacture,
        data[0],
        { skipHeader: false },
      ),
      new SheetExcel(
        'Ligne de facture',
        columnsLigneFacture,
        data[1],
        { skipHeader: false },
      ),
    ],
  );
}

export function generatedTemplateFacture() {
  const commande = {
    code: 'T9822030033',
    dateDevisCommande: '17/03/2022',
    agence: 'Nanterre',
    commercial: 'Dupont Pierre',
    assistant: 'Dupont Laure',
    annonceur: 'E123',
    payeur: 'E123',
    mandataire: 'NON',
    donneurOrdre: 'E123',
    etat: 'Enregistre',
    datePremierAffichage: '1/04/2022',
    renouvelable: 'Oui',
    reconductible: 'Oui',
    dateRenouvellement: '1/04/2022',
    datePreavis: '1/04/2022',
    montantHt: '847,00',
  };
  const ligneCommande = {
    codeCommande: 'T9822030033',
    referenceProduit: 'IMPRESSION',
    libelle: 'Impression de 6 affiches',
    quantite: 1,
    prixUnitaire: 160,
    tauxTVA: 20,
  };
  const config = templateConfig([[commande], [ligneCommande]]);
  ExportToExcel(config);
}
